export default __webpack_public_path__ + "static/media/regulatory--no-snowmobiles--g2.2e3d9be1.png";